
<template>
  <div>
    <div v-if="this.learningData.length > 0">
      <div v-if="userInfo.vipType==='1'">
        <a-card-grid
          class="project-card-grid"
          v-for="(item, i) in learningData"
          :key="i"
          style="padding: 24px 10px;"
        >
          <a-card
            :bordered="false"
            :body-style="{ padding: 0 }"
            :style="{cursor:'pointer'}"
            @click="onChange(item.id,item.typeId)"
          >
            <img
              :style="{width: '100%',height:'140px'}"
              :src="item.culumPhoto"
            />
            <div style="padding-top: 10px;">
              <span>
                <a-tag color="blue">{{ item.typeName }}</a-tag>
              </span>
              <span>
                <ellipsis
                  :length="35"
                  tooltip
                >
                  {{ item.name }}
                </ellipsis>
              </span>
            </div>
          </a-card>
        </a-card-grid>
      </div>
      <div v-else>
        <a-card-grid
          class="project-card-grid"
          v-for="(item, i) in learningData"
          :key="i"
          style="padding: 24px 10px;"
        >
          <a-card
            :bordered="false"
            :body-style="{ padding: 0 }"
            :style="{cursor:'pointer'}"
            @click="i == 0 ? onChange(item.id,item.typeId) : changeByCarg()"
          >
            <img
              :style="{width: '100%',height:'140px'}"
              :src="item.culumPhoto"
            />
            <div style="padding-top: 10px;">
              <span>
                <a-tag color="blue">{{ item.typeName }}</a-tag>
              </span>
              <span>
                <ellipsis
                  :length="35"
                  tooltip
                >
                  {{ item.name }}
                </ellipsis>
              </span>
            </div>
          </a-card>
        </a-card-grid>
      </div>
    </div>
    <div
      v-else
      style="text-align: center;line-height: 100px;"
    >
      暂无数据
    </div>
  </div>
</template>
<script>
import { getCourseList } from '@/api/workspace/workspace'
import Ellipsis from '@/components/Ellipsis'
import { mapGetters } from 'vuex'
export default {
  name: 'RecommendForm',
  components: {
    Ellipsis
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  data () {
    return {
      learningData: []
    }
  },
  created () {
    // console.log('userInfo:' + JSON.stringify(this.userInfo))
    getCourseList(this.queryParam).then(res => {
      this.learningData = res.result
    })
  },
  methods: {
    onChange (id, typeId) {
      localStorage.setItem('courseId', id)
      localStorage.setItem('typeId', typeId)
      this.$router.push({ name: 'CourseVideo' })
    },
    changeByCarg () {
      this.$confirm({
        title: '购买云卡，升级解锁全部资源？',
        // content: '退出后将保存做题进度',
        okText: '升级',
        cancelText: '取消',
        okButtonProps: {
          on: {
            click: this.clickHandler
          }
        }
      })
    },
    clickHandler () {
      this.$router.push({ path: '/cloudCard' })
    }
  }
}
</script>
